import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import axios from '../../../../Lib/axios';

const Popup = () => {
    const [popupData, setPopupData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 이전 방문 날짜 (로컬스토리지에서 가져오기, 숫자로 변환)
    const VISITED_BEFORE_DATE = Number(localStorage.getItem('VisitCookie'));
    // 현재 날짜 (일 단위)
    const VISITED_NOW_DATE = new Date().getDate();

    useEffect(() => {
        // 팝업 오늘 하루 닫기 체크
        if (VISITED_BEFORE_DATE === VISITED_NOW_DATE) {
            setIsOpen(false);
            setLoading(false);
            return;
        }

        setLoading(true);
        axios
            .get('/v1/popup/list')
            .then(response => {
                const now = new Date();

                // startDate와 endDate를 비교하여 유효한 팝업 필터링
                const validPopups = response.data.data.filter(popup => {
                    const startDate = new Date(popup.startDate);
                    const endDate = new Date(popup.endDate);

                    return popup.isPublic && now >= startDate && now <= endDate;
                });

                if (validPopups.length > 0) {
                    setPopupData(validPopups[0]);
                    setIsOpen(true);
                } else {
                    console.log('유효한 팝업이 없습니다.');
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('팝업 데이터를 불러오는 중 오류 발생:', error);
                setError(error);
                setLoading(false);
            });
    }, [VISITED_BEFORE_DATE, VISITED_NOW_DATE]);

    // 오늘 하루 닫기
    const handleDayClose = () => {
        localStorage.setItem('VisitCookie', String(VISITED_NOW_DATE)); // 숫자 -> 문자열로 변환하여 저장
        setIsOpen(false);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={handleClose} style={modalStyles}>
            {popupData && (
                <PopupContainer>
                    <PopupImage src={popupData.photo} alt='팝업 이미지' />
                    <CloseStyle>
                        <Close onClick={handleDayClose}>오늘 하루 닫기</Close>
                        <Close onClick={handleClose}>닫기</Close>
                    </CloseStyle>
                </PopupContainer>
            )}
        </Modal>
    );
};

export default Popup;

const PopupContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    background: #282828;
    border-radius: 10px;
    text-align: center;

    @media (max-width: 768px) {
        width: auto;
        height: 400px;
    }
`;

const PopupImage = styled.img`
    max-width: 100%;
    height: 400px;
    border-radius: 8px;

    @media (max-width: 768px) {
        width: auto;
        height: 350px;
    }
`;

const CloseStyle = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: #282828;
    width: 100%;
    margin-top: 10px;
    padding: 5px;
    border-radius: 0 0 15px 15px;
    color: #ffffff;
    font-size: 13px;
`;

const Close = styled.span`
    cursor: pointer;
`;

const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
        width: '350px',
        height: 'fit-content',
        margin: 'auto',
        padding: '0',
        borderRadius: '10px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
};
